module.exports = __webpack_public_path__ + "static/media/starlogo.542985e2.png";